import { render, staticRenderFns } from "./CSalesVariance.vue?vue&type=template&id=54152504&scoped=true"
import script from "./CSalesVariance.vue?vue&type=script&lang=ts"
export * from "./CSalesVariance.vue?vue&type=script&lang=ts"
import style0 from "./CSalesVariance.vue?vue&type=style&index=0&id=54152504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54152504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VRow,VSimpleTable})
